import { Box, Skeleton } from '@mui/material';
import React from 'react';
import DashboardCardsSkeleton from './DashboardCardsSkeleton';
import DashboardPlotSkeleton from './DashboardPlotSkeleton';

/**
 * HomeSkeleton
 *
 * Skeleton for the Home component that matches the dashboard layout:
 * - Welcome message at the top
 * - 5 stats cards in a row
 * - Session Overview chart (left side)
 * - Sessions Insight gauge chart (right side)
 * - Bottom section with tables
 */
const HomeSkeleton = () => {
  return (
    <div className="p-2">
      {/* Welcome title */}
      <Box className="mb-3">
        <Skeleton variant="text" width={240} height={32} />
      </Box>

      {/* Stats cards row */}
      <DashboardCardsSkeleton cardCount={5} />

      <DashboardPlotSkeleton />
    </div>
  );
};

export default HomeSkeleton;
